module.exports = __webpack_public_path__ + "static/media/biometria_ah10.5fbc87d9.mp4";